<app-dialog-wrapper
  [title]="'results.detailedEyeAnalysis.title' | translate"
  [severity]="severity"
>
  <div>
    <div class="charset-list modal-wrapper">
      <div class="modal-charset-list"></div>
      <p class="m-t-10">
        {{ "results.detailedEyeAnalysis.description" | translate }}
      </p>

      @for (item of eyeData; track item; let idx = $index) {
      <div class="modal-charset">
        <h5>{{ eyeData[idx].category | translate }}</h5>
        <ul class="charset-list-container">
          <li *ngIf="eyeData[idx].detected_marks !== null">
            <p>
              {{ "results.detailedEyeAnalysis.detectedMarks" | translate }}
              <span class="bright-pink"
                ><b>{{ eyeData[idx].detected_marks }}</b></span
              >
            </p>
          </li>
          @for (data of eyeData[idx].detected_types; track data; let ix =
          $index) { @if (eyeData[idx].detected_types[ix].type) {
          <li>
            <p>
              {{ "results.detailedEyeAnalysis.detectedTypes" | translate }}
              <span class="bright-pink"
                ><b>{{
                  eyeData[idx].detected_types[ix].type | translate
                }}</b></span
              >
            </p>
          </li>
          }
          <li>
            <p>
              {{ "results.detailedEyeAnalysis.severityLevel" | translate }}
              <span class="bright-pink text-capital"
                ><b>{{ eyeData[idx].detected_types[ix].severity | translate }}</b></span
              >
            </p>
          </li>
          <p class="m-t-10">
            {{ eyeData[idx].detected_types[ix].content | translate }}
          </p>
          }
        </ul>
      </div>
      }
    </div>
  </div>
</app-dialog-wrapper>
